import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../utils/cropUtils';
import './CropModal.css';

const CropModal = ({ imageSrc, onClose, onCropComplete, aspect = 4 / 3 }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropCompleteInternal = useCallback((_, areaPixels) => {
        setCroppedAreaPixels(areaPixels);
    }, []);

    const handleDone = async () => {
        if (!croppedAreaPixels) return alert("Crop area not ready yet");
        try {
            const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels, aspect);

            onCropComplete(croppedBlob);
        } catch (err) {
            console.error('Crop failed:', err);
        }
    };

    if (!imageSrc) return null;

    return (
        <div className="crop-modal-overlay">
            <div className="crop-modal-content">
                <div className="cropper-wrapper">
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspect} // ✅ dynamic aspect
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropCompleteInternal}
                    />
                </div>
                <div className="crop-slider-wrapper">
                    <label style={{ color: "#fff" }}>Zoom</label>
                    <input
                        type="range"
                        min="1"
                        max="3"
                        step="0.05"
                        value={zoom}
                        onChange={(e) => setZoom(Number(e.target.value))}
                    />
                </div>

                <div className="crop-modal-controls">
                    <button onClick={onClose}>Cancel</button>
                    <button onClick={handleDone}>Crop & Select</button>
                </div>
            </div>
        </div>
    );
};

export default CropModal;